import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";
import { saveCustomTableStateWebStorage } from "../../../../pages/tables/custom/customTableObjectType/customTableObjectTypeFunctions";
import { delay } from "../../../../features/dataFunctions/dataFunctions";

const nextPageIcon = require('../../../../assets/images/icons/nextTablePageIcon.svg').default
const previousPageIcon = require('../../../../assets/images/icons/previousTablePageIcon.svg').default

export function getBasicTablePaginator(pageInputTooltip: string, setPaginatorPageInputTooltip: any, tableState: any, setTableState: any, dataCount: number, objectType: any) {
    const onPageInputChange = (event: any) => {
        let page = event.value
        if (page < 1 || (page - 1) * 100 > dataCount) {
            setPaginatorPageInputTooltip(`Значение от 1 до ${Math.floor(dataCount / 100) + 1}.`);
        } else {
            let tableStateCopy: any = {};
            Object.assign(tableStateCopy, tableState, { page: page - 1 }, { first: (page - 1) * 100 })
            setTableState(tableStateCopy)
            saveCustomTableStateWebStorage(tableStateCopy, objectType)
            setPaginatorPageInputTooltip("Введите номер страницы.");
        }
    }
    return {
        layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown JumpToPageInput",
        PageLinks: (options: any) => {
            if ((options.view.startPage === options.page && options.view.startPage !== 0) || (options.view.endPage === options.page && options.page + 1 !== options.totalPages)) {
                return;
            }

            return (
                <button type="button" className={options.className} onClick={options.onClick}>
                    {options.page + 1}
                </button>
            );
        },
        PrevPageLink: (options: any) => {
            return (
                <button type="button" className={classNames(options.className, "previousPageTableButton")} onClick={options.onClick} disabled={options.disabled}>
                    <img src={previousPageIcon} />
                </button>
            );
        },
        NextPageLink: (options: any) => {
            return (
                <button type="button" className={classNames(options.className, "nextPageTableButton")} onClick={options.onClick} disabled={options.disabled}>
                    <img src={nextPageIcon} />
                </button>
            );
        },
        JumpToPageInput: (options: any) => {
            let tooltipOptions = {
                className: 'go-to-page-tooltip'
            }
            return (
                <span className="go-to-page-span">
                    <span className="go-to-page-text">Страница</span>
                    <InputNumber
                        size={2}
                        className="ml-1"
                        id="page-number-input"
                        tooltip={pageInputTooltip}
                        tooltipOptions={tooltipOptions}
                        value={options.value}
                        onChange={(event) => delay(() => onPageInputChange(event), 400)}
                    />
                </span>
            );
        }
    };
}